import type {
  IResponseApi,
  IResponseApiSearch
} from '@/modules/Core/interfaces/api/IApis'
import { BaseService } from '@/modules/Core/services/BaseService'
import type { AxiosResponse } from 'axios'
import { type IConfTarifarios } from '@/modules/Contratacion/interfaces'
export class TarifarioService extends BaseService<IConfTarifarios> {
  constructor () {
    super({
      baseUrl: 'system/tariffs/'
    })
  }
  async getGenerales(): Promise<AxiosResponse<IResponseApi<IConfTarifarios>>> {
    return this.http.get<IResponseApi<IConfTarifarios>>(`/general`)
  }
}
